import { render, staticRenderFns } from "./otherView.vue?vue&type=template&id=b156ae0e&scoped=true"
import script from "./otherView.vue?vue&type=script&lang=js"
export * from "./otherView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b156ae0e",
  null
  
)

export default component.exports